import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Button, Box, HStack } from '@tq/ui-components';

import { AssigneeDetails, PageHeading } from 'components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { Consultation } from 'types';
import { useResponse } from '../../hooks';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

type ResponseHeaderProps = {
  consultation: Consultation | undefined;
};

export const ResponseHeader: React.FC<ResponseHeaderProps> = ({ consultation }) => {
  const { t } = useTranslation('response_header');
  const isMobile = useIsMobile();
  const formatLocaleDate = useFormatLocaleDate();
  const { id } = useParams();
  const consultationId = +(id ?? 0);
  const { canSubmit, submitResponse } = useResponse(consultationId);

  const showButton = consultation && !consultation.isArchived;

  return (
    <Box data-testid='response-page-heading'>
      {isMobile ? (
        <Box>
          <PageHeading
            heading={
              consultation?.isArchived
                ? t(
                    'consultation_response_archived_mobile',
                    'Consultation response (Archived)'
                  )
                : t('consultation_response', 'Consultation response')
            }
          />
        </Box>
      ) : (
        <HStack justifyContent='space-between' gridGap={6}>
          <PageHeading
            heading={
              consultation?.isArchived
                ? t(
                    'consultation_response_archived',
                    'Consultation response {{ responseDate }} (Archived)',
                    { responseDate: formatLocaleDate(consultation?.lastVisitedDate) }
                  )
                : t('consultation_response', 'Consultation response')
            }
          />

          {showButton && (
            <Button
              fontSize='sm'
              variant='primary'
              isDisabled={!canSubmit}
              onClick={submitResponse}
            >
              {t('submit', 'Submit')}
            </Button>
          )}
        </HStack>
      )}
      <AssigneeDetails />
    </Box>
  );
};
